import {useMutation, useQuery} from "vue-query";
import {useBrand} from "../hooks/useBrand";
import {queryClient} from "../client";
const {current, updateCurrent} = useBrand()

export const currentBrand = () => useQuery('brandCurrent', () => current());
export const updateCurrentBrand = () => useMutation('brandCurrent', (data) => updateCurrent(data), {
  onSuccess: (response) => {
    queryClient.setQueryData('brandCurrent', response);
  }
})
